import { correlationService } from '../api/CorrelationService';

// Helper function to get the base server URL from environment
function getBaseServerUrl(): string {
  // In Vite environment, import.meta.env is available
  // In test environment, we use the default
  return import.meta.env.VITE_APP_BASE_SERVER_URL || 'http://localhost:3000';
}

export const ToLogout = () => {
  // Clear correlation token before other logout operations
  correlationService.clear();
  sessionStorage.clear();
  window.location.href = getBaseServerUrl() + '/auth/logout';
};
